export const StoreTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  LOGIN_CHECK: "LOGIN_CHECK",
};
